import { Text } from '@foss/legion-ui'
import { useLinkProps } from '../routing/router'
import type { ThemeMode } from '../theme/useThemeMode'
import { LEGION_UI_VERSION } from '../version'
import styles from './TopBar.module.css'

function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </svg>
  )
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
    </svg>
  )
}

function MenuIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M4 7h16M4 12h16M4 17h16" />
    </svg>
  )
}

export interface TopBarProps {
  mode: ThemeMode
  onToggleTheme: () => void
  onOpenNav: () => void
  navOpen: boolean
}

export function TopBar({
  mode,
  onToggleTheme,
  onOpenNav,
  navOpen,
}: TopBarProps) {
  const home = useLinkProps('/')
  return (
    <header className={styles.bar} data-testid="top-bar">
      <button
        type="button"
        className={styles.navToggle}
        onClick={onOpenNav}
        aria-expanded={navOpen}
        aria-controls="side-nav"
        aria-label={navOpen ? 'Close navigation' : 'Open navigation'}
        data-testid="nav-toggle"
      >
        <MenuIcon />
      </button>

      <a {...home} className={styles.brand} data-testid="brand">
        <Text variant="label" as="span" className={styles.brandName}>
          legion-ui
        </Text>
        <span className={styles.version} data-testid="version-badge">
          v{LEGION_UI_VERSION}
        </span>
      </a>

      <button
        type="button"
        className={styles.themeToggle}
        onClick={onToggleTheme}
        aria-label={`Switch to ${mode === 'dark' ? 'light' : 'dark'} theme`}
        data-testid="theme-toggle"
        data-mode={mode}
      >
        {mode === 'dark' ? <MoonIcon /> : <SunIcon />}
      </button>
    </header>
  )
}
